<template>
  <div>
    <Loader v-if="$apolloData.loading" />
    <div v-else class="content" id="top">
      <div class="title-text">
        <p class="title">New Messages</p>
      </div>
      <div class="content-body">
        <div class="message-card">
          <div class="card-top">
            <div class="title">
              <span class="card-title">Message your fans</span>
              <p class="card-text">
                Send an SMS to your fans.
              </p>
            </div>
          </div>
          <BulkMessageInput
            :fans="subscribers"
            :submitting="submitting"
            :editingMessage="editingMessage"
            @submit="submit"
            @cancelEditing="editingMessage = null"
          />
        </div>
        <div class="scheduled-messages" v-if="!editingMessage">
          <div class="card-top">
            <span class="card-title">Scheduled Messages</span>
            <p class="card-text">
              Messages scheduled in the future
            </p>
          </div>
          <div class="card-content">
            <div class="messages" v-if="scheduled_messages.length">
              <div
                class="message-container"
                v-for="(message, i) in scheduled_messages"
                :key="i"
              >
                <div class="details">
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-users"></i>
                    </div>
                    <div class="text">
                      {{ message | formatSendTo }}
                    </div>
                  </div>
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-dollar-sign"></i>
                    </div>
                    <div class="text">
                      ${{ subscribers | formatCost(message.location) }}
                    </div>
                  </div>
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-clock"></i>
                    </div>
                    <div class="text" v-if="!message.link_destination">
                      {{ message | formatDate }}
                    </div>
                    <div class="text" v-else>On Release</div>
                  </div>
                  <div class="actions">
                    <button
                      class="button-default"
                      @click="editingMessage = message"
                    >
                      <div class="icon">
                        <i class="fa-solid fa-pencil"></i>
                      </div>
                      <span class="text">Edit</span>
                    </button>
                  </div>
                </div>
                <div class="message">
                  {{ message.message }}
                </div>
              </div>
            </div>
            <div class="no-messages" v-else>
              <span class="message-text">
                You don't have any scheduled messages
              </span>
            </div>
          </div>
        </div>
        <div class="scheduled-messages" v-if="!editingMessage">
          <div class="card-top">
            <span class="card-title">Sent Messages</span>
            <!-- <p class="card-text">
              Sent Messages
            </p> -->
          </div>
          <div class="card-content">
            <div class="messages" v-if="sent_messages.length">
              <div
                class="message-container"
                v-for="(message, i) in sent_messages"
                :key="i"
              >
                <div class="details">
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-users"></i>
                    </div>
                    <div class="text">
                      {{ (message.recipient_count || 0) + " Subscribers" }}
                    </div>
                  </div>
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-hand-back-point-up"></i>
                    </div>
                    <div class="text">
                      283 Clicks
                    </div>
                  </div>
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-reply"></i>
                    </div>
                    <div class="text">
                      {{ message.replies.aggregate.count }} Replies
                    </div>
                  </div>
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-ban"></i>
                    </div>
                    <div class="text">
                      {{ message.optouts.aggregate.count }} Opt-outs
                    </div>
                  </div>
                </div>
                <div class="message">
                  {{ message.message }}
                </div>
                <div class="time">{{ message | formatDate }}</div>
              </div>
            </div>
            <div class="no-messages" v-else>
              <span class="message-text">
                You haven't sent any messages yet
              </span>
            </div>
          </div>
        </div>
      </div>
      <SnackBar />
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Swal from "sweetalert2";

import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import SnackBar from "@/components/Custom/SnackBar";
import Loader from "@/components/Custom/Loader";
import BulkMessageInput from "@/components/Custom/BulkMessageInput";
import {
  Q_SUBSCRIBERS_COUNT,
  M_SCHEDULE_MESSAGE,
  Q_SCHEDULED_MESSAGES,
  M_UPDATE_SCHEDULED_MESSAGE,
  M_DELETE_SCHEDULED_MESSAGE,
  Q_SENT_MESSAGES
} from "@/graphql";

export default {
  name: "Messages",
  components: {
    SnackBar,
    Loader,
    BulkMessageInput
  },
  data() {
    return {
      subscribers: {
        world: 0,
        us_canada: 0
      },
      submitting: false,
      scheduled_messages: [],
      sent_messages: [],
      editingMessage: null
    };
  },
  apollo: {
    subscribers_count: {
      query: Q_SUBSCRIBERS_COUNT,
      result({ data }) {
        this.subscribers = {
          world: data.subscribers_world.aggregate.count,
          us_canada: data.subscribers_us_canada.aggregate.count
        };
      },
      variables() {
        return {
          artist_id: this.artist.id
        };
      },
      update: data => data
    },
    scheduled_messages: {
      query: Q_SCHEDULED_MESSAGES,
      result({ data }) {
        this.scheduled_messages = data.bulk_messages;
      },
      variables() {
        return {
          artist_id: this.artist.id,
          now: new Date()
        };
      },
      update: data => data
    },
    sent_messages: {
      query: Q_SENT_MESSAGES,
      result({ data }) {
        this.sent_messages = data.bulk_messages;
      },
      variables() {
        return {
          artist_id: this.artist.id,
          now: new Date()
        };
      },
      update: data => data
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    }
  },
  methods: {
    async submit(data) {
      return this.editingMessage
        ? await this.editMessage(data)
        : await this.scheduleMessage(data);
    },
    async scheduleMessage({ send_at, message, location }) {
      if (!send_at) {
        const { value: confirm } = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonText: "Yes, send it!",
          type: "warning",
          confirmButtonClass: "button-secondary big",
          cancelButtonClass: "button-danger big",
          buttonsStyling: false
        });

        if (!confirm) return;
      }

      this.submitting = true;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_SCHEDULE_MESSAGE,
        variables: {
          artist_id: this.artist.id,
          message,
          location,
          send_at: send_at
            ? moment
                .parseZone(
                  `${send_at.date} ${send_at.time}${moment(send_at.date)
                    .tz(send_at.timezone)
                    .format("Z")}`
                )
                .format()
            : new Date()
        }
      });

      this.submitting = false;

      if (send_at) await this.$apollo.queries.scheduled_messages.refetch();
    },
    async editMessage({ id, send_at, message, location }) {
      if (!send_at) {
        const { value: confirm } = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonText: "Yes, send it!",
          type: "warning",
          confirmButtonClass: "button-secondary big",
          cancelButtonClass: "button-danger big",
          buttonsStyling: false
        });

        if (!confirm) return;
      }

      this.submitting = true;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_UPDATE_SCHEDULED_MESSAGE,
        variables: {
          id,
          message,
          location,
          send_at: send_at
            ? moment
                .parseZone(
                  `${send_at.date} ${send_at.time}${moment(send_at.date)
                    .tz(send_at.timezone)
                    .format("Z")}`
                )
                .format()
            : new Date()
        }
      });

      this.submitting = false;
      this.editingMessage = null;

      return this.$apollo.queries.scheduled_messages.refetch();
    },
    async deleteMessage(id) {
      const { value: confirm } = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        type: "warning",
        confirmButtonClass: "button-secondary big",
        cancelButtonClass: "button-danger big",
        buttonsStyling: false
      });

      if (!confirm) return;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_DELETE_SCHEDULED_MESSAGE,
        variables: {
          id
        }
      });

      await this.$apollo.queries.scheduled_messages.refetch();
    }
  },
  filters: {
    formatDate(message) {
      return message.link_destination
        ? moment(message.link_destination.link.release_time).format(
            "MMM DD, YYYY hh:mm a"
          )
        : moment(message.send_at).format("MMM DD, YYYY hh:mm a");
    },
    formatSendTo(message) {
      if (message.location === "world") return "Worldwide";
      if (message.location === "us_canada") return "US & Canada";
      if (message.link_destination) return "Drop Subscribers + Worldwide";
    },
    formatCost(subscribers, location) {
      const costUsCanada = subscribers.us_canada * 0.01;
      const costWorldRest = (subscribers.world - subscribers.us_canada) * 0.05;
      const cost =
        location === "us_canada" ? costUsCanada : costWorldRest + costUsCanada;
      return cost.toFixed(2);
    },
    formatSentTo(message, count) {
      let description = "";
      if (message.location === "world") description = "Worldwide";
      if (message.location === "us_canada") description = "US & Canada";
      if (message.link_destination)
        description = "Drop Subscribers + Worldwide";

      if (count) description += ` (${count} fans)`;

      return description;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 30px;
  .title-text {
    margin-top: 30px;
  }
  .content-body {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    .message-card {
      width: 100%;
      background: $bg-type-2;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      padding: 20px;
      margin-bottom: 20px;
      .card-top {
        display: flex;
        justify-content: space-between;
        .title {
          display: flex;
          flex-direction: column;
          .card-title {
            font-size: 18px;
            font-weight: 600;
            color: white;
            margin-bottom: 10px;
          }
          .card-text {
            font-size: 14px;
            font-weight: 400;
            color: $text-type-0;
            margin-bottom: 10px;
          }
        }
        .editing {
          color: $purple;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
      }
    }
    .scheduled-messages {
      width: 100%;
      background: $bg-type-2;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      padding: 20px 35px;
      margin-bottom: 50px;
      .card-top {
        display: flex;
        flex-direction: column;
        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: white;
          margin-bottom: 10px;
        }
        .card-text {
          font-size: 14px;
          font-weight: 400;
          color: $text-type-0;
          margin-bottom: 10px;
        }
      }
      .card-content {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        .messages {
          display: flex;
          flex-direction: column;
          gap: 45px;
          .message-container {
            width: 100%;
            .details {
              background: $bg-type-1;
              display: flex;
              justify-content: space-around;
              padding: 15px 0;
              border-radius: 5px;
              .element {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #fff;
                .text {
                  margin-top: 8px;
                  font-size: 13px;
                  font-weight: 600;
                }
              }
              button {
                padding: 8px 16px;
                display: flex;
                gap: 10px;
                font-size: 15px;
              }
            }
            .message {
              border-radius: 0px 0px 14px 14px;
              padding: 18px 25px;
              background: #fff;
              color: #000;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                z-index: 0;
                bottom: 0;
                right: -8px;
                height: 20px;
                width: 20px;
                background: #fff;
                border-bottom-left-radius: 15px;
              }

              &:after {
                content: "";
                position: absolute;
                z-index: 1;
                bottom: 0;
                right: -10px;
                width: 10px;
                height: 20px;
                background: $bg-type-2;
                border-bottom-left-radius: 10px;
              }
            }
            .time {
              margin-left: auto;
              margin-right: 5px;
              margin-top: 10px;
              width: fit-content;
              color: #c9c9c9;
              font-size: 14px;
              font-style: normal;
            }
          }
        }
        .messages-list {
          width: 100%;
          border-collapse: collapse;
          thead {
            tr {
              th {
                padding: 18px 18px 10px 10px;
                font-weight: 600;
                font-size: 12px;
                line-height: 15px;
                color: $text-type-0;
              }
            }
          }
          tbody {
            tr {
              background: $bg-type-1;
              border-bottom: solid 5px transparent;
              td {
                padding: 6px;
                font-weight: 600;
                font-size: 14px;
                line-height: 22px;
                color: white;
                mix-blend-mode: normal;
                opacity: 0.9;
                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }
                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }
                &.actions {
                  span {
                    margin: 0 10px;
                    color: $purple;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
